import { api } from "@/service";
import type { TWorkspace } from "@/types";
import { AxiosError } from "axios";

export class WorkspaceService {
   async getWorkspaces() {
      return api
         .get<TWorkspace[]>("/workspaces")
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }
   async getWorkspace(slug: string) {
      return api
         .get<Required<TWorkspace>>(`/workspaces/${slug}`)
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }
}
